import {reaction as $42h8L$reaction, observable as $42h8L$observable, computed as $42h8L$computed, action as $42h8L$action} from "mobx";
import {sleep as $42h8L$sleep, getVisibleText as $42h8L$getVisibleText} from "web-utility";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c6af500b4433b08b$exports = {};

$parcel$export($c6af500b4433b08b$exports, "SpeechSynthesisState", function () { return $c6af500b4433b08b$export$bf098d6e10b5582a; });
$parcel$export($c6af500b4433b08b$exports, "SpeechSynthesisModel", function () { return $c6af500b4433b08b$export$6c5d58455f3ab236; });


var $c6af500b4433b08b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c6af500b4433b08b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c6af500b4433b08b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c6af500b4433b08b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c6af500b4433b08b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c6af500b4433b08b$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($c6af500b4433b08b$export$bf098d6e10b5582a || ($c6af500b4433b08b$export$bf098d6e10b5582a = {}));
let $c6af500b4433b08b$export$6c5d58455f3ab236 = (()=>{
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    let _instanceExtraInitializers = [];
    let _state_decorators;
    let _state_initializers = [];
    let _state_extraInitializers = [];
    let _get_language_decorators;
    return _a = class SpeechSynthesisModel {
        get state() {
            return $c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
        }
        set state(value) {
            $c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
        }
        get language() {
            var _b, _c;
            return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
        }
        constructor(i18n){
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $c6af500b4433b08b$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    var _b;
                    this.state = $c6af500b4433b08b$export$bf098d6e10b5582a.Clear;
                    (_b = $c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $42h8L$reaction)(()=>i18n.currentLanguage, this.clear), "f");
            globalThis.addEventListener("unload", this.clear);
        }
        static getVoices() {
            const voices = speechSynthesis.getVoices();
            return voices[0] ? Promise.resolve(voices) : new Promise((resolve)=>{
                (0, $42h8L$sleep)(1).then(()=>resolve([]));
                speechSynthesis.onvoiceschanged = ()=>resolve(speechSynthesis.getVoices());
            });
        }
        speak(text) {
            return $c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function*() {
                const { language: language } = this, content = new SpeechSynthesisUtterance(text), voices = yield _a.getVoices();
                content.voice = voices.find(({ localService: localService, lang: lang })=>localService && lang === language) || voices.find(({ default: backup })=>backup);
                const result = new Promise((resolve, reject)=>{
                    content.onend = resolve;
                    content.onerror = reject;
                });
                speechSynthesis.speak(content);
                this.state = $c6af500b4433b08b$export$bf098d6e10b5582a.Speaking;
                try {
                    yield result;
                } finally{
                    this.clear();
                }
            });
        }
        toggle() {
            if (this.state === $c6af500b4433b08b$export$bf098d6e10b5582a.Speaking) {
                speechSynthesis.pause();
                this.state = $c6af500b4433b08b$export$bf098d6e10b5582a.Pause;
            } else {
                speechSynthesis.resume();
                this.state = $c6af500b4433b08b$export$bf098d6e10b5582a.Speaking;
            }
        }
        static *walk(range) {
            const { commonAncestorContainer: commonAncestorContainer, endContainer: endContainer } = range;
            const walker = document.createNodeIterator(commonAncestorContainer);
            var current;
            while(current = walker.nextNode()){
                if (range.intersectsNode(current)) yield current;
                if (commonAncestorContainer !== endContainer && current === endContainer) break;
            }
        }
        static getSelectedText(box) {
            var _b;
            const range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
            if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError("No text selected");
            return [
                ...this.walk(range)
            ].filter(({ nodeType: nodeType, parentNode: parentNode })=>{
                if (nodeType !== 3) return;
                const { width: width, height: height } = parentNode.getBoundingClientRect();
                return width && height;
            }).map(({ nodeValue: nodeValue }, index, { length: length })=>nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity)).filter((text)=>text.trim()).join("").trim();
        }
        static getReadableText(box) {
            try {
                return this.getSelectedText(box);
            } catch (_b) {
                return (0, $42h8L$getVisibleText)(box);
            }
        }
    }, _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $42h8L$observable)
        ];
        _get_language_decorators = [
            (0, $42h8L$computed)
        ];
        $c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: (obj)=>"state" in obj,
                get: (obj)=>obj.state,
                set: (obj, value)=>{
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: (obj)=>"language" in obj,
                get: (obj)=>obj.language
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $d1a4b21e19b1b67c$exports = {};

$parcel$export($d1a4b21e19b1b67c$exports, "TranslationModel", function () { return $d1a4b21e19b1b67c$export$d91823dfc159395b; });

var $552a56cc5ff3f479$exports = {};

$parcel$export($552a56cc5ff3f479$exports, "isNumberLetter", function () { return $552a56cc5ff3f479$export$df0b442c7f8df5c1; });
$parcel$export($552a56cc5ff3f479$exports, "textJoin", function () { return $552a56cc5ff3f479$export$d977f7cd0cb45fe1; });
$parcel$export($552a56cc5ff3f479$exports, "parseCookie", function () { return $552a56cc5ff3f479$export$d0eaf3e94be578f6; });
$parcel$export($552a56cc5ff3f479$exports, "setCookie", function () { return $552a56cc5ff3f479$export$110700823644f4a6; });
$parcel$export($552a56cc5ff3f479$exports, "parseLanguageHeader", function () { return $552a56cc5ff3f479$export$2557e81a557a81ea; });
const $552a56cc5ff3f479$export$df0b442c7f8df5c1 = (raw = "")=>new RegExp("\\p{N}", "u").test(raw) || new RegExp("\\p{Ll}", "u").test(raw.toLowerCase());
const $552a56cc5ff3f479$export$d977f7cd0cb45fe1 = (...parts)=>parts.map((raw, index)=>{
        var _a;
        const isNL = $552a56cc5ff3f479$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        const diff = isNL !== $552a56cc5ff3f479$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? " " : "");
    }).join("");
const $552a56cc5ff3f479$export$d0eaf3e94be578f6 = (value = globalThis.document.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split("="))) : {};
function $552a56cc5ff3f479$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === "boolean" ? value ? key : "" : `${key}=${value}`).filter(Boolean).join("; ");
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
const $552a56cc5ff3f479$export$2557e81a557a81ea = (value)=>value.split(",").map((language)=>{
        const [name, quantity = ""] = language.split(";");
        const [_, value = "1"] = quantity.split("=");
        return [
            name.trim(),
            +value
        ];
    }).sort(([_, a], [__, b])=>b - a).map(([name])=>name);


var $d1a4b21e19b1b67c$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d1a4b21e19b1b67c$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d1a4b21e19b1b67c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d1a4b21e19b1b67c$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $d1a4b21e19b1b67c$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $d1a4b21e19b1b67c$export$d91823dfc159395b = (()=>{
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    let _instanceExtraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _currentLanguage_decorators;
    let _currentLanguage_initializers = [];
    let _currentLanguage_extraInitializers = [];
    let _currentMap_decorators;
    let _currentMap_initializers = [];
    let _currentMap_extraInitializers = [];
    let _get_defaultMap_decorators;
    let _changeLanguage_decorators;
    return _a = class TranslationModel {
        get loading() {
            return $d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
        }
        set loading(value) {
            $d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
        }
        get currentLanguage() {
            return $d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
        }
        set currentLanguage(value) {
            $d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
        }
        get currentMap() {
            return $d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
        }
        set currentMap(value) {
            $d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
        }
        get defaultMap() {
            return this.configuration[this.defaultLanguage];
        }
        constructor(configuration){
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers)
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ""));
            _TranslationModel_currentMap_accessor_storage.set(this, ($d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(const name in configuration)if (typeof configuration[name] !== "function") this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError("One static language map is required");
            if (!globalThis.window) return;
            const languages = [
                (0, $552a56cc5ff3f479$export$d0eaf3e94be578f6)().language,
                ...navigator.languages || [
                    this.defaultLanguage
                ]
            ].filter(Boolean);
            this.loadLanguages(languages);
            window.addEventListener("languagechange", ()=>this.changeLanguage(navigator.language));
        }
        onLanguageChange(handler) {
            (0, $42h8L$reaction)(()=>this.currentLanguage, (currentLanguage, lastLanguage)=>{
                if (lastLanguage) handler.call(this, currentLanguage);
            });
        }
        setLanguage(name) {
            var _b;
            this.currentLanguage = name;
            if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) (0, $552a56cc5ff3f479$export$110700823644f4a6)("language", document.documentElement.lang = name, {
                path: "/"
            });
        }
        changeLanguage(name) {
            return $d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                const language = this.configuration[name];
                if (typeof language !== "function") {
                    this.setLanguage(name);
                    return this.currentMap = language;
                }
                this.loading = true;
                const { default: map } = yield language();
                this.loading = false;
                this.setLanguage(name);
                return this.currentMap = this.configuration[name] = map;
            });
        }
        loadLanguages(names) {
            return $d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                const languages = Object.keys(this.configuration).sort(({ length: a }, { length: b })=>b - a);
                for (const name of names){
                    const language = languages.includes(name) ? name : languages.find((language)=>name.startsWith(language) || language.startsWith(name));
                    if (language) try {
                        return yield this.changeLanguage(language);
                    } catch (_b) {}
                }
                return this.changeLanguage(this.defaultLanguage);
            });
        }
        textOf(key, data) {
            const value = this.currentMap[key] || this.defaultMap[key];
            if (typeof value !== "function") return value;
            if (!data) throw ReferenceError("Input data is required for Translation Resolver");
            return value(data);
        }
    }, _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $42h8L$observable)
        ];
        _currentLanguage_decorators = [
            (0, $42h8L$observable)
        ];
        _currentMap_decorators = [
            (0, $42h8L$observable)
        ];
        _get_defaultMap_decorators = [
            (0, $42h8L$computed)
        ];
        _changeLanguage_decorators = [
            (0, $42h8L$action)
        ];
        $d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentLanguage" in obj,
                get: (obj)=>obj.currentLanguage,
                set: (obj, value)=>{
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentMap" in obj,
                get: (obj)=>obj.currentMap,
                set: (obj, value)=>{
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defaultMap" in obj,
                get: (obj)=>obj.defaultMap
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $d1a4b21e19b1b67c$var$__esDecorate(_a, null, _changeLanguage_decorators, {
            kind: "method",
            name: "changeLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"changeLanguage" in obj,
                get: (obj)=>obj.changeLanguage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();





export {$c6af500b4433b08b$export$bf098d6e10b5582a as SpeechSynthesisState, $c6af500b4433b08b$export$6c5d58455f3ab236 as SpeechSynthesisModel, $d1a4b21e19b1b67c$export$d91823dfc159395b as TranslationModel, $552a56cc5ff3f479$export$df0b442c7f8df5c1 as isNumberLetter, $552a56cc5ff3f479$export$d977f7cd0cb45fe1 as textJoin, $552a56cc5ff3f479$export$d0eaf3e94be578f6 as parseCookie, $552a56cc5ff3f479$export$110700823644f4a6 as setCookie, $552a56cc5ff3f479$export$2557e81a557a81ea as parseLanguageHeader};
//# sourceMappingURL=index.esm.js.map
